import { useEffect, useState } from 'react';

import { CHECKLIST_RECALCULATION_SPINNER_TIMEOUT_MS } from 'constants/checklists';

// HZ-4124: a checklist whose regeneration never reports back stays InProgress server-side, so the
// spinner would animate forever. The key identifies WHICH checklists are recalculating, so a
// genuine new recalculation restarts the cutoff instead of inheriting an earlier stuck one's expiry.
// The cutoff is deliberately per-mount and not persisted — a reload shows the spinner again until
// the server-side watchdog resolves the snapshot.
export const useChecklistRecalculationTimeout = recalculatingKey => {
  const [hasTimedOut, setHasTimedOut] = useState(false);

  useEffect(() => {
    setHasTimedOut(false);

    if (!recalculatingKey) {
      return undefined;
    }

    const timerId = setTimeout(
      () => setHasTimedOut(true),
      CHECKLIST_RECALCULATION_SPINNER_TIMEOUT_MS,
    );

    return () => clearTimeout(timerId);
  }, [recalculatingKey]);

  return hasTimedOut;
};
